import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import { Button } from "react-bootstrap";
import { MdCheck } from "react-icons/md";
import _ from "lodash";
import { PopupModal } from "../alert/alert.Dismiss";
import { CONFIRM_BALANCE } from "../../../graphql/orderGroup/mutation";
import { errorSwal, successSwal } from "../../../helpers/sweetalert";

//* ຕ້ອງກົງກັບ .limit(50) ຂອງ confirmBalance ໃນ 4b-cf-api — ສົ່ງເກີນນີ້ໃນຮອບດຽວ ບິນທີ່ເກີນຈະຫາຍງຽບໆ
const CONFIRM_BALANCE_BATCH_SIZE = 50;

const ConfirmBalance = ({ setSelectedIds, idIn }) => {
    const [modalShow, setModalShow] = useState(false);
    const [sending, setSending] = useState(false);
    const [sentBatches, setSentBatches] = useState(0);
    const [confirmBalance] = useMutation(CONFIRM_BALANCE);

    const batches = _.chunk(idIn || [], CONFIRM_BALANCE_BATCH_SIZE);

    const close = () => {
        setSelectedIds([]);
        setModalShow(false);
        setSentBatches(0);
    };

    const onSend = async () => {
        setSending(true);
        let success = 0;
        let failed = 0;
        let errored = 0;
        let lastError = "";

        //* ເທື່ອລະຊຸດ ບໍ່ສົ່ງພ້ອມກັນ: backend ຈຳກັດອັດຕາສົ່ງຂອງ Meta ຕໍ່ຊຸດຢູ່ແລ້ວ
        for (let i = 0; i < batches.length; i += 1) {
            try {
                const { data } = await confirmBalance({
                    variables: { where: { id: batches[i] } },
                });
                success += data?.confirmBalance?.success || 0;
                failed += data?.confirmBalance?.failed || 0;
            } catch (error) {
                const message = error?.message || "";
                //* ORDER_GROUP_NOT_FOUND = ຊຸດນີ້ບໍ່ມີບິນເຂົ້າເງື່ອນໄຂ ບໍ່ແມ່ນຂໍ້ຜິດພາດ
                if (!message.includes("ORDER_GROUP_NOT_FOUND")) {
                    errored += batches[i].length;
                    lastError = message;
                    console.log("confirm balance batch error: ", error);
                }
            }
            setSentBatches(i + 1);
        }

        const skipped = (idIn?.length || 0) - success - failed - errored;
        const lines = [`ສົ່ງສຳເລັດ ${success} ບິນ`];
        if (failed > 0) lines.push(`ສົ່ງບໍ່ສຳເລັດ ${failed} ບິນ`);
        if (errored > 0) lines.push(`ເກີດຂໍ້ຜິດພາດ ${errored} ບິນ (${lastError})`);
        if (skipped > 0) {
            lines.push(`ຂ້າມ ${skipped} ບິນ (ຍັງບໍ່ຈ່າຍ, ເຄີຍແຈ້ງແລ້ວ ຫຼື ເກີນ 7 ມື້)`);
        }

        setSending(false);
        close();
        if (failed > 0 || errored > 0 || success === 0) {
            errorSwal(lines.join(" • "), success > 0 ? "warning" : undefined);
        } else {
            successSwal(lines.join(" • "));
        }
    };

    return (
        <>
            <Button
                className="w-100 text-left"
                variant="light"
                disabled={idIn?.length >= 1 ? false : true}
                onClick={() => setModalShow(true)}
            > <MdCheck />ແຈ້ງຮັບຍອດ</Button>
            <PopupModal
                show={modalShow}
                onCancel={close}
                title="ແຈ້ງຮັບຍອດ"
                centered="ສົ່ງຂໍຄວາມຮັບຍອດລູກຄ້າທາງ Messenger"
                content={
                    sending
                        ? `ກຳລັງສົ່ງຊຸດທີ ${Math.min(sentBatches + 1, batches.length)}/${batches.length} ກະລຸນາລໍຖ້າ...`
                        : `ເລືອກໄວ້ ${idIn?.length || 0} ບິນ ລະບົບຈະສົ່ງເທື່ອລະ ${CONFIRM_BALANCE_BATCH_SIZE} ບິນຈົນຄົບ ແລ້ວສະຫຼຸບຜົນໃຫ້`
                }
                bgColor="bg-success text-white"
                apiPath={CONFIRM_BALANCE}
                customSubmit={onSend}
                submitting={sending}
            />
        </>
    );
};

export default ConfirmBalance;
